import { styled} from "@mui/material";
import {Box} from "@mui/system";

const OverFlow = styled(Box)({
  overflowX: "hidden",
  overflowY: 'auto',
  '&::-webkit-scrollbar': {display: 'none'}
});

export default OverFlow